import config from "config/config";
import { useDeviceSize } from "hooks";
import { Grid } from "modules/common/components/Grid";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import { Box, Flex, VStack, Image } from "@chakra-ui/react";
import type { GlobalRankingProps } from "./GlobalRanking.d";
import { headingStyles } from "./GlobalRanking.styles";

const GlobalRanking = ({ heading, text, imageSrc }: GlobalRankingProps) => {
  const { isDesktop } = useDeviceSize();
  const bgImage = isDesktop ? `url(${config.staticUrl}/i/homepage/decoration-img-triangles-2.svg)` : "none";

  return (
    <Box bg="greyscale.300" bgImage={bgImage} bgRepeat="no-repeat" bgPosition="-20% -10%" py={{ base: 14, lg: 24 }}>
      <Grid mb={0}>
        <Flex gridColumn={{ base: "span 1", md: "span 12" }} flexDir="column">
          <Flex
            flexDir={{ base: "column", lg: "row" }}
            justify="space-between"
            mb={{ base: 14, lg: 12 }}
            align={{ base: "flex-start", lg: "flex-end" }}
          >
            <RichtextAdapter content={heading} customStyles={headingStyles} />
          </Flex>
          <Flex flexDir={{ base: "column", lg: "row" }} alignItems={{ base: "flex-start", lg: "unset" }}>
            {imageSrc && (
              <Image
                order={{ base: 1, lg: 0 }}
                minW={{ base: "100%", md: "368px" }}
                maxH="206px"
                src={imageSrc}
                alignSelf={{ base: "unset", md: "center", lg: "unset" }}
              />
            )}
            <VStack align="left" spacing={2} ml={{ base: 0, lg: 24 }} mb={{ base: 4, lg: 0 }}>
              <RichtextAdapter content={text} customStyles={{}} />
            </VStack>
          </Flex>
        </Flex>
      </Grid>
    </Box>
  );
};

export default GlobalRanking;
